<div class="outer">
  <div class="inner">
    <div class="bg"></div>
    <div class="content"  #content >
      <h1 class="title">HOURS</h1>
      <ul style="margin: 0; padding: 0; width: 80%;">
        <li *ngFor="let hour of hours$ | async; trackBy: identify" [ngClass]="{'animateIn': triggerAnimation}">
          <div class="list-item" style="display: flex; justify-content: space-between">
            <p class="day-long">{{hour.day}}: </p>
            <p class="day-short">{{hour.dayShort}}: </p>
            <p *ngIf="hour.closed">CLOSED</p>
            <p *ngIf="!hour.closed">{{hour.open}} - {{hour.close}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
